import axios from 'axios';

export default {
    async fetchDocuments(props) {
        let url = '/cars/documents';
        if (props) {
            let i = 0;
            for (const [key, value] of Object.entries(props)) {
                if (value) {
                    if (i !== 0) {
                        url += '&';
                    } else {
                        url += '?';
                    }
                    url += key + '=' + value;
                    i++;
                }
            }
        }
        return axios.get(url);
    },

    async fetchDocument(id) {
        return axios.get('/cars/documents/' + id);
    },

    async fetchDocumentFiles(id) {
        return axios.get(`/cars/documents/${id}/files`);
    },

    async fetchDocumentDefinitions() {
        return axios.get('/cars/documents/definitions');
    },

    async updateDocument(document) {
        return axios.put('/cars/documents',
            document,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
    },

    async createDocument(document) {
        return axios.post('/cars/documents',
            document,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
    },

    async deleteDocument(documentId) {
        return axios.delete('/cars/documents/' + documentId);
    },

    async uploadFiles(documentId, files) {
        const formData = new FormData();
        files.forEach(file => formData.append('files', file, file.name.split('.')[0]));
        formData.append('documentId', documentId);
        return axios.post('/cars/documents/upload-files',
            formData,
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }
        );
    },

    async archiveDocumentFiles(files) {
        return axios.post('/cars/documents/files/archive',
            files.map(file => file.id),
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
    }
}
